import { render, staticRenderFns } from "./FormularioDatosPersonales.vue?vue&type=template&id=4e7da7d0&scoped=true"
import script from "./FormularioDatosPersonales.vue?vue&type=script&lang=js"
export * from "./FormularioDatosPersonales.vue?vue&type=script&lang=js"
import style0 from "./FormularioDatosPersonales.vue?vue&type=style&index=0&id=4e7da7d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7da7d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCardTitle,VCol,VRadio,VRadioGroup,VRow,VTextField})
